import { render } from "./Plants.vue?vue&type=template&id=4e704409"
import script from "./Plants.vue?vue&type=script&lang=js"
export * from "./Plants.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__